<template>
  <div class="page-not-found">
    <h1>404 - Page Not Found</h1>
    <h2>Don't sweat it but you might not be going to the right page.</h2>
    <img src="../assets/images/charlie-sweating.jpg" />
    <Button v-bind:title="`Back to ${redirectPage}`" v-bind:type="'raised'" v-bind:colorTheme="'primary'" v-on:button-click="backToHome" />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Button from '@/components/form-elements/Button';

export default {
  name: 'PageNotFound',
  components: { Button },
  created() {
    this.isLoggedIn()
  },
  data() {
    return {
      userIsLoggedIn: '',
      redirectPage: ''
    }
  },
  methods: {
    backToHome() {
      this.$router.replace({ name: 'projects' })
    },
    isLoggedIn() {
      this.userIsLoggedIn = firebase.auth().currentUser
      this.setRedirectPage()
    },
    setRedirectPage() {
      this.redirectPage = this.userIsLoggedIn ? 'Projects' : 'Login'
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/colors';
@import '../assets/styles/mixin';

.page-not-found {
  @include flex(column, center, center);

  h1 {
    margin-bottom: 16px;
  }

  img {
    width: 100%;
    max-width: 540px;
    margin: 24px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue